// extracted by mini-css-extract-plugin
export default {"root":"CollectionControlBar_root__IrE-0","searchInput":"CollectionControlBar_searchInput__jZzx5"};